/**
 * ****************************************************************************
 * @description     :   Reducer to receive action and change state for page report
 * @created at      :   2020/07/18
 * @created by      :   QuanHVM
 * @package         :   report-daily-react
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import types of action will process
 */
import Types from './action-types';

/**
 * Initial state of page report
 */
const initialState = {
    /**
     * Data of reports
     */
    reports: [],
    /**
     * Data of report detail
     */
    report: {},
    /**
     * Data of time report
     */
    timeLines: [],
    /**
     * varible show popup
     */
    isShowPopup: false,
    /**
     * condition search
     */
    condition: {
        search: '',
        time: '',
        date: '',
        customer: '',
        behavior: ''
    }
}

/**
 * Reducer to process change data for page reports
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/18 - create
 * @param  : {Object} state - Current sate of page reports
 * @param  : {Object} action - information of action will process
 * @access : public
 */
export default function reportReducer (state = initialState, action) {
    switch (action.type) {
    /**
     * get list data report when call api success
     */
    case Types.FETCHING_REPORTS_SUCCESS:
        return {
            ...state,
            reports: action.data[0],
            timeLines: action.data[1]
        }
    /**
     * get list data report when call api failure
     */
    case Types.FETCHING_REPORTS_FAILURE:
        return {
            ...state,
            reports: []
        }
    /**
     * get list data report checkbox
     */
    case Types.CHECKBOX_REPORT:
        return {
            ...state,
            reports: action.reports
        }
    /**
     * get list data report when sucess
     */
    case Types.FETCHING_REPORT_DETAIL_SUCCESS:
        return {
            ...state,
            report: action.data
        }
    /**
     * get list data report when failure
     */
    case Types.FETCHING_REPORT_DETAIL_FAILURE:
        return {
            ...state,
            report: {}
        }
    /**
     * get varible show popup report
     */
    case Types.IS_SHOW_POPUP_REPORT_DETAIL:
        return {
            ...state,
            isShowPopup: !state.isShowPopup
        }
    default:
        return state
    }
}
